import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { colorShade } from '@twnel/web-components';
import styled from 'styled-components/macro';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const DeleteButton = styled.div`
  display: none;
  transition: transform 0.8s ease;
`;

const Button = styled.div`
  background-color: ${({ theme }) => colorShade(9, theme.actionable)};
  color: ${({ theme }) => theme.foreground};
  cursor: pointer;
  display: flex;
  align-items: center;
  border: none;
  outline: none;
  padding: 18px;
  transition: background-color 0.6s ease;

  &:hover {
    ${DeleteButton} {
      color: ${({ theme }) => theme.error};
      display: flex;
      justify-content: flex-end;
      margin-right: 0.8rem;
    }

    background-color: ${({ theme }) => colorShade(8, theme.actionable)};
  }
`;

const Title = styled.p`
  font-weight: 600;
  font-size: 0.8rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex-grow: 1;
`;

const Content = styled.div`
  background-color: white;
  overflow: hidden;
  transition: max-height 0.6s ease;
  font-weight: 400;
  font-size: 0.8rem;
  max-height: ${({ maxHeight }) => maxHeight};
`;

const Chevron = styled.div`
  margin-left: auto;
  transition: transform 0.6s ease;
  color: ${({ theme }) => colorShade(5, theme.actionable)};

  &.rotate {
    transform: rotate(180deg);
  }
`;

const Accordion = ({ title, children, onDeleteItem }) => {
  const [state, setState] = useState({
    active: '',
    height: '0px',
    rotate: '',
  });

  const contentRef = useRef(null);

  const toggleAccordion = () => {
    const newActive = state.active === '' ? 'active' : '';
    setState({
      active: newActive,
      height: newActive === '' ? '0px' : `${contentRef.current.scrollHeight}px`,
      rotate: newActive === 'active' ? 'rotate' : '',
    });
  };

  return (
    <Wrapper>
      <Button className={`${state.active}`} onClick={toggleAccordion}>
        <Title>{title}</Title>
        <DeleteButton onClick={onDeleteItem}>
          <i className="fas fa-trash" />
        </DeleteButton>
        <Chevron className={`${state.rotate}`}>
          <i className="fas fa-chevron-down" />
        </Chevron>
      </Button>
      <Content ref={contentRef} maxHeight={`${state.height}`}>
        {children}
      </Content>
    </Wrapper>
  );
};

Accordion.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  onDeleteItem: PropTypes.func.isRequired,
};

export default Accordion;
